import { TranslationKey } from 'providers/i18n/types';
import { useTranslate as raUseTranslate } from 'react-admin';

export type UseTypedTranslateReturnType = (
  key: TranslationKey,
  options?: Record<string, any>,
) => string;

export const useTypedTranslate = () => {
  const translate = raUseTranslate();
  return (key: TranslationKey, options?: Record<string, any>) => translate(key, options);
};
